import { useMemo } from "react";

import { unFlattenObject } from "@utils/utils";

import { useDataSourceDetailsContext } from "../../providers";

export const useRawDataTab = () => {
  const { dataSourceDetails } = useDataSourceDetailsContext();

  const jsonData = useMemo(() => {
    if (!dataSourceDetails?.data) return {};

    return unFlattenObject(dataSourceDetails.data);
  }, [dataSourceDetails]);

  return {
    jsonData,
  };
};
